import environment, { Environment } from './base'

const baseApi = 'http://localhost:8081'
const additionalProps = {
  isProduction: false,
  isDevelopment: true,
}
const env = environment(baseApi, additionalProps)

const developmentEnv: Environment = {
  ...env,
  api: {
    ...env.api,
  },
  ...additionalProps,
}

export default developmentEnv
